import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Vehicle Rules API calls
 */
const vehicleRuleService = {
  /**
   * Get all vehicle rules with pagination and filters
   */
  getAllRules: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_RULES.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleRuleService.getAllRules'));
    }
  },

  /**
   * Get a single vehicle rule by ID
   */
  getRuleById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.VEHICLE_RULES.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleRuleService.getRuleById'));
    }
  },

  /**
   * Create a new vehicle rule
   */
  createRule: async (ruleData) => {
    try {
      return await apiClient.post(API_ENDPOINTS.VEHICLE_RULES.CREATE, ruleData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleRuleService.createRule'));
    }
  },

  /**
   * Update a vehicle rule
   */
  updateRule: async (id, ruleData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.VEHICLE_RULES.UPDATE(id), ruleData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleRuleService.updateRule'));
    }
  },

  /**
   * Delete a vehicle rule
   */
  deleteRule: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_RULES.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleRuleService.deleteRule'));
    }
  },

  /**
   * Delete multiple vehicle rules
   */
  deleteMultipleRules: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_RULES.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'vehicleRuleService.deleteMultipleRules'));
    }
  },

  /**
   * Toggle rule status
   */
  toggleRuleStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.VEHICLE_RULES.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleRuleService.toggleRuleStatus'));
    }
  },
};

export default vehicleRuleService;
